import { useMemo } from "react";
import { Figure, FigureProps } from "../Figure";

type returnFigures = {
  Figures: (React.FC<FigureProps> | (() => null))[];
};
/**
 * @description genera una lista aleatoria con figuras.
 */
export const useGenerateFigures = (recreate: boolean): returnFigures => {
  const circulos: Array<typeof Figure> = [];
  const cantFiguras = Math.floor(Math.random() * 4) + 5;
  for (let index = 0; index < cantFiguras; index++) {
    circulos.push(Figure);
  }
  return useMemo(
    () => ({
      Figures: circulos
    }),
    [recreate]
  );
};
